import { first, isEmpty, isNull, isUndefined, List } from "lodash";
import dayjs from "dayjs";

export const defineColorBySeverity = (
  severity: Notification | undefined,
  rgb = false,
): string => {
  const postfix = rgb ? "rgb-color" : "color";
  switch (severity) {
    default:
      return `var(--primary-${postfix})`;
  }
};

type CountryCodeMap = {
  [key: string]: string;
};
export interface ServiceLevel {
  serviceLevelCode: string;
  serviceLevelDescription: string;
}
export interface DelByValue {
  delByValueCode: string;
  delByValueDescription: string;
}
export const countryCodes: CountryCodeMap = {
  ARUBA: "aw",
  AFGHANISTAN: "af",
  ANGOLA: "ao",
  ANGUILLA: "ai",
  ALBANIA: "al",
  ANDORRA: "ad",
  "NETHERLANDS ANTILLES": "an",
  "UNITED ARAB EMIRATES": "ae",
  ARGENTINA: "ar",
  ARMENIA: "am",
  "AMERICAN SAMOA": "as",
  ANTARCTICA: "aq",
  "ANTIGUA AND BARBUDA": "ag",
  AUSTRALIA: "au",
  AUSTRIA: "at",
  AZERBAIJAN: "az",
  BURUNDI: "bi",
  BELGIUM: "be",
  BENIN: "bj",
  "BURKINA FASO": "bf",
  BANGLADESH: "bd",
  BULGARIA: "bg",
  BAHRAIN: "bh",
  BAHAMAS: "bs",
  "BOSNIA AND HERZEGOVINA": "ba",
  BELARUS: "by",
  BELIZE: "bz",
  BERMUDA: "bm",
  BOLIVIA: "bo",
  BRAZIL: "br",
  BARBADOS: "bb",
  "BRUNEI DARUSSALAM": "bn",
  BHUTAN: "bt",
  BOTSWANA: "bw",
  "CTRL AFRICAN REPUBLIC": "cf",
  CANADA: "ca",
  "COCOS (KEELING) ISLANDS": "cc",
  SWITZERLAND: "ch",
  CHILE: "cl",
  CHINA: "cn",
  "COTE D'IVOIRE": "ci",
  CAMEROON: "cm",
  "CONGO (DEMOCRATIC REP)": "cd",
  "CONGO (REPUBLIC OF)": "cg",
  "COOK ISLANDS": "ck",
  COLOMBIA: "co",
  COMOROS: "km",
  "CAPE VERDE": "cv",
  "COSTA RICA": "cr",
  CUBA: "cu",
  "CHRISTMAS ISLAND": "cx",
  "CAYMAN ISLANDS": "ky",
  CYPRUS: "cy",
  "CZECH REPUBLIC": "cz",
  GERMANY: "de",
  DJIBOUTI: "dj",
  DOMINICA: "dm",
  DENMARK: "dk",
  "DOMINICAN REPUBLIC": "do",
  ALGERIA: "dz",
  ECUADOR: "ec",
  EGYPT: "eg",
  ERITREA: "er",
  "WESTERN SAHARA": "eh",
  SPAIN: "es",
  ESTONIA: "ee",
  ETHIOPIA: "et",
  FINLAND: "fi",
  FIJI: "fj",
  "FALKLAND ISLANDS": "fk",
  FRANCE: "fr",
  "FAROE ISLANDS": "fo",
  MICRONESIA: "fm",
  GABON: "ga",
  "UNITED KINGDOM": "gb",
  GEORGIA: "ge",
  GHANA: "gh",
  GIBRALTAR: "gi",
  GUINEA: "gn",
  GUADELOUPE: "gp",
  GAMBIA: "gm",
  "GUINEA-BISSAU": "gw",
  "EQUATORIAL GUINEA": "gq",
  GREECE: "gr",
  GRENADA: "gd",
  GREENLAND: "gl",
  GUATEMALA: "gt",
  "FRENCH GUIANA": "gf",
  GUAM: "gu",
  GUYANA: "gy",
  "HONG KONG": "hk",
  "HEARD ISLAND & MCDONALD ISLANDS": "hm",
  HONDURAS: "hn",
  CROATIA: "hr",
  HAITI: "ht",
  HUNGARY: "hu",
  INDONESIA: "id",
  INDIA: "in",
  "BRITISH INDIAN OCEAN TERRITORY": "io",
  IRELAND: "ie",
  IRAN: "ir",
  IRAQ: "iq",
  ICELAND: "is",
  ISRAEL: "il",
  ITALY: "it",
  JAMAICA: "jm",
  JORDAN: "jo",
  JAPAN: "jp",
  KAZAKHSTAN: "kz",
  KENYA: "ke",
  KYRGYZSTAN: "kg",
  CAMBODIA: "kh",
  KIRIBATI: "ki",
  "ST KITTS AND NEVIS": "kn",
  "KOREA (SOUTH)": "kr",
  KUWAIT: "kw",
  LAO: "la",
  LEBANON: "lb",
  LIBERIA: "lr",
  LIBYA: "ly",
  "ST LUCIA": "lc",
  LIECHTENSTEIN: "li",
  "SRI LANKA": "lk",
  LESOTHO: "ls",
  LITHUANIA: "lt",
  LUXEMBOURG: "lu",
  LATVIA: "lv",
  "MACAO / CHINA": "mo",
  MOROCCO: "ma",
  MONACO: "mc",
  "REPUBLIC OF MOLDOVA": "md",
  MADAGASCAR: "mg",
  MALDIVES: "mv",
  MEXICO: "mx",
  "MARSHALL ISLANDS": "mh",
  MACEDONIA: "mk",
  MALI: "ml",
  MALTA: "mt",
  "MYANMAR (BURMA)": "mm",
  MONGOLIA: "mn",
  "MARIANA ISLANDS": "mp",
  MOZAMBIQUE: "mz",
  MAURITANIA: "mr",
  MONTSERRAT: "ms",
  MARTINIQUE: "mq",
  MAURITIUS: "mu",
  MALAWI: "mw",
  MALAYSIA: "my",
  MAYOTTE: "yt",
  NAMIBIA: "na",
  "NEW CALEDONIA": "nc",
  NIGER: "ne",
  "NORFOLK ISLAND": "nf",
  NIGERIA: "ng",
  NICARAGUA: "ni",
  NIUE: "nu",
  NETHERLANDS: "nl",
  NORWAY: "no",
  NEPAL: "np",
  NAURU: "nr",
  "NEW ZEALAND": "nz",
  OMAN: "om",
  PAKISTAN: "pk",
  PANAMA: "pa",
  PITCAIRN: "pn",
  PERU: "pe",
  PHILIPPINES: "ph",
  PALAU: "pw",
  "PAPUA NEW GUINEA": "pg",
  POLAND: "pl",
  "PUERTO RICO": "pr",
  "KOREA (NORTH)": "kp",
  PORTUGAL: "pt",
  PARAGUAY: "py",
  PALESTINE: "ps",
  "FRENCH POLYNESIA": "pf",
  QATAR: "qa",
  REUNION: "re",
  ROMANIA: "ro",
  "RUSSIAN FEDERATION": "ru",
  RWANDA: "rw",
  "SAUDI ARABIA": "sa",
  "SERBIA AND MONTENEGRO": "cs",
  SUDAN: "sd",
  SENEGAL: "sn",
  SINGAPORE: "sg",
  "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": "gs",
  "ST HELENA": "sh",
  "SVALBARD/JAN MAYEN": "sj",
  "SOLOMON ISLANDS": "sb",
  "SIERRA LEONE": "sl",
  "EL SALVADOR": "sv",
  "SAN MARINO": "sm",
  SOMALIA: "so",
  "ST PIERRE/MIQUELON": "pm",
  "SAO TOME AND PRINCIPE": "st",
  SURINAME: "sr",
  SLOVAKIA: "sk",
  SLOVENIA: "si",
  SWEDEN: "se",
  SWAZILAND: "sz",
  SEYCHELLES: "sc",
  "SYRIAN ARAB REPUBLIC": "sy",
  "TURKS/CAICOS ISLANDS": "tc",
  CHAD: "td",
  TOGO: "tg",
  THAILAND: "th",
  TAJIKISTAN: "tj",
  TOKELAU: "tk",
  TURKMENISTAN: "tm",
  "EAST TIMOR": "tl",
  TONGA: "to",
  "TRINIDAD AND TOBAGO": "tt",
  TUNISIA: "tn",
  TURKEY: "tr",
  TUVALU: "tv",
  TAIWAN: "tw",
  TANZANIA: "tz",
  UGANDA: "ug",
  UKRAINE: "ua",
  "UNITED STATES MINOR OUTLYING ISLANDS": "um",
  URUGUAY: "uy",
  "UNITED STATES": "us",
  UZBEKISTAN: "uz",
  "HOLY SEE (VATICAN)": "va",
  "ST VINCENT/GRENADINES": "vc",
  VENEZUELA: "ve",
  "BRITISH VIRGIN ISLANDS": "vg",
  "US VIRGIN ISLANDS": "vi",
  "VIET NAM": "vn",
  VANUATU: "vu",
  "WALLIS/FUTUNA ISLANDS": "wf",
  SAMOA: "ws",
  "INSTALLATIONS IN INTERNATIONAL WATERS": "xw",
  "TIMOR-LESTE": "tl",
  YEMEN: "ye",
  YUGOSLAVIA: "yu",
  "SOUTH AFRICA": "za",
  ZAMBIA: "zm",
  ZIMBABWE: "zw",
};

export const getDialCodeBasedOnCountryName: any = {
  ARUBA: "297",
  AFGHANISTAN: "93",
  ANGOLA: "244",
  ANGUILLA: "1264",
  ALBANIA: "355",
  ANDORRA: "376",
  "NETHERLANDS ANTILLES": "599",
  "UNITED ARAB EMIRATES": "971",
  ARGENTINA: "54",
  ARMENIA: "374",
  "AMERICAN SAMOA": "1684",
  ANTARCTICA: "672",
  "ANTIGUA AND BARBUDA": "1268",
  AUSTRALIA: "61",
  AUSTRIA: "43",
  AZERBAIJAN: "994",
  BURUNDI: "257",
  BELGIUM: "32",
  BENIN: "229",
  "BURKINA FASO": "226",
  BANGLADESH: "880",
  BULGARIA: "359",
  BAHRAIN: "973",
  BAHAMAS: "1242",
  "BOSNIA AND HERZEGOVINA": "387",
  BELARUS: "375",
  BELIZE: "501",
  BERMUDA: "1441",
  BOLIVIA: "591",
  BRAZIL: "55",
  BARBADOS: "1246",
  "BRUNEI DARUSSALAM": "673",
  BHUTAN: "975",
  BOTSWANA: "267",
  "CTRL AFRICAN REPUBLIC": "236",
  CANADA: "1",
  "COCOS (KEELING) ISLANDS": "61",
  SWITZERLAND: "41",
  CHILE: "56",
  CHINA: "86",
  "COTE D'IVOIRE": "225",
  CAMEROON: "237",
  "CONGO (DEMOCRATIC REP)": "243",
  "CONGO (REPUBLIC OF)": "242",
  "COOK ISLANDS": "682",
  COLOMBIA: "57",
  COMOROS: "269",
  "CAPE VERDE": "238",
  "COSTA RICA": "506",
  CUBA: "53",
  "CHRISTMAS ISLAND": "61",
  "CAYMAN ISLANDS": "1345",
  CYPRUS: "357",
  "CZECH REPUBLIC": "420",
  GERMANY: "49",
  DJIBOUTI: "253",
  DOMINICA: "1767",
  DENMARK: "45",
  "DOMINICAN REPUBLIC": "1809",
  ALGERIA: "213",
  ECUADOR: "593",
  EGYPT: "20",
  ERITREA: "291",
  "WESTERN SAHARA": "212",
  SPAIN: "34",
  ESTONIA: "372",
  ETHIOPIA: "251",
  FINLAND: "358",
  FIJI: "679",
  "FALKLAND ISLANDS": "500",
  FRANCE: "33",
  "FAROE ISLANDS": "298",
  MICRONESIA: "691",
  GABON: "241",
  "UNITED KINGDOM": "44",
  GEORGIA: "995",
  GHANA: "233",
  GIBRALTAR: "350",
  GUINEA: "224",
  GUADELOUPE: "590",
  GAMBIA: "220",
  "GUINEA-BISSAU": "245",
  "EQUATORIAL GUINEA": "240",
  GREECE: "30",
  GRENADA: "1473",
  GREENLAND: "299",
  GUATEMALA: "502",
  "FRENCH GUIANA": "594",
  GUAM: "1671",
  GUYANA: "592",
  "HONG KONG": "852",
  "HEARD ISLAND & MCDONALD ISLANDS": "672",
  HONDURAS: "504",
  CROATIA: "385",
  HAITI: "509",
  HUNGARY: "36",
  INDONESIA: "62",
  INDIA: "91",
  "BRITISH INDIAN OCEAN TERRITORY": "246",
  IRELAND: "353",
  IRAN: "98",
  IRAQ: "964",
  ICELAND: "354",
  ISRAEL: "972",
  ITALY: "39",
  JAMAICA: "1876",
  JORDAN: "962",
  JAPAN: "81",
  KAZAKHSTAN: "7",
  KENYA: "254",
  KYRGYZSTAN: "996",
  CAMBODIA: "855",
  KIRIBATI: "686",
  "ST KITTS AND NEVIS": "1869",
  "KOREA (SOUTH)": "82",
  KUWAIT: "965",
  LAO: "856",
  LEBANON: "961",
  LIBERIA: "231",
  LIBYA: "218",
  "ST LUCIA": "1758",
  LIECHTENSTEIN: "423",
  "SRI LANKA": "94",
  LESOTHO: "266",
  LITHUANIA: "370",
  LUXEMBOURG: "352",
  LATVIA: "371",
  "MACAO / CHINA": "853",
  MOROCCO: "212",
  MONACO: "377",
  "REPUBLIC OF MOLDOVA": "373",
  MADAGASCAR: "261",
  MALDIVES: "960",
  MEXICO: "52",
  "MARSHALL ISLANDS": "692",
  MACEDONIA: "389",
  MALI: "223",
  MALTA: "356",
  "MYANMAR (BURMA)": "95",
  MONGOLIA: "976",
  "MARIANA ISLANDS": "1670",
  MOZAMBIQUE: "258",
  MAURITANIA: "222",
  MONTSERRAT: "1664",
  MARTINIQUE: "596",
  MAURITIUS: "230",
  MALAWI: "265",
  MALAYSIA: "60",
  MAYOTTE: "262",
  NAMIBIA: "264",
  "NEW CALEDONIA": "687",
  NIGER: "227",
  "NORFOLK ISLAND": "672",
  NIGERIA: "234",
  NICARAGUA: "505",
  NIUE: "683",
  NETHERLANDS: "31",
  NORWAY: "47",
  NEPAL: "977",
  NAURU: "674",
  "NEW ZEALAND": "64",
  OMAN: "968",
  PAKISTAN: "92",
  PANAMA: "507",
  PITCAIRN: "870",
  PERU: "51",
  PHILIPPINES: "63",
  PALAU: "680",
  "PAPUA NEW GUINEA": "675",
  POLAND: "48",
  "PUERTO RICO": "1",
  "KOREA (NORTH)": "850",
  PORTUGAL: "351",
  PARAGUAY: "595",
  PALESTINE: "970",
  "FRENCH POLYNESIA": "689",
  QATAR: "974",
  REUNION: "262",
  ROMANIA: "40",
  "RUSSIAN FEDERATION": "7",
  RWANDA: "250",
  "SAUDI ARABIA": "966",
  "SERBIA AND MONTENEGRO": "381",
  SUDAN: "249",
  SENEGAL: "221",
  SINGAPORE: "65",
  "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": "500",
  "ST HELENA": "290",
  "SVALBARD/JAN MAYEN": "47",
  "SOLOMON ISLANDS": "677",
  "SIERRA LEONE": "232",
  "EL SALVADOR": "503",
  "SAN MARINO": "378",
  SOMALIA: "252",
  "ST PIERRE/MIQUELON": "508",
  "SAO TOME AND PRINCIPE": "239",
  SURINAME: "597",
  SLOVAKIA: "421",
  SLOVENIA: "386",
  SWEDEN: "46",
  SWAZILAND: "268",
  SEYCHELLES: "248",
  "SYRIAN ARAB REPUBLIC": "963",
  "TURKS/CAICOS ISLANDS": "1649",
  CHAD: "235",
  TOGO: "228",
  THAILAND: "66",
  TAJIKISTAN: "992",
  TOKELAU: "690",
  TURKMENISTAN: "993",
  "EAST TIMOR": "670",
  TONGA: "676",
  "TRINIDAD AND TOBAGO": "1868",
  TUNISIA: "216",
  TURKEY: "90",
  TUVALU: "688",
  TAIWAN: "886",
  TANZANIA: "255",
  UGANDA: "256",
  UKRAINE: "380",
  "UNITED STATES MINOR OUTLYING ISLANDS": "1",
  URUGUAY: "598",
  "UNITED STATES": "1",
  UZBEKISTAN: "998",
  "HOLY SEE (VATICAN)": "379",
  "ST VINCENT/GRENADINES": "1784",
  VENEZUELA: "58",
  "BRITISH VIRGIN ISLANDS": "1284",
  "US VIRGIN ISLANDS": "1340",
  "VIET NAM": "84",
  VANUATU: "678",
  "WALLIS/FUTUNA ISLANDS": "681",
  SAMOA: "685",
  "INSTALLATIONS IN INTERNATIONAL WATERS": "870",
  "TIMOR-LESTE": "670",
  YEMEN: "967",
  YUGOSLAVIA: "381",
  "SOUTH AFRICA": "27",
  ZAMBIA: "260",
  ZIMBABWE: "263",
};

export const getCountryCodes = (
  countryListData: { countryCode: string; countryName: string }[],
) => {
  return countryListData.map((country) => ({
    value: country.countryCode?.toLowerCase(),
    label: country.countryName,
    code: country.countryCode,
  }));
};

export const getDialNumberBasedOnCountry = (countryName: any) => {
  return getDialCodeBasedOnCountryName[countryName?.label];
};

export const getErrorMessageString = (e: any) => {
  return e?.response?.status === 401 &&
    isUndefined(e?.response?.data?.errorMessage)
    ? e.message
    : e?.response?.data?.errorMessage;
};

export const getPhoneWithExtensions = (
  data: any,
  countryListData: any[],
  countryCode: any,
) => {
  if (!isNull(data)) {
    const phoneNo = data?.phoneNo;
    const phoneExt = data?.phoneExt;
    const associatedCountry =
      !isEmpty(countryListData) &&
      first(
        countryListData?.filter(
          (country: { countryCode: any }) =>
            country.countryCode === countryCode,
        ),
      );
    const associatedCountryExt = getDialNumberBasedOnCountry(associatedCountry);
    let phoneNumber = "";
    if (!isNull(phoneExt) && !isNull(phoneNo)) {
      phoneNumber = `${phoneExt}${phoneNo}`;
    } else if (
      isNull(phoneExt) &&
      !isNull(phoneNo) &&
      !isUndefined(associatedCountryExt)
    ) {
      phoneNumber = `${associatedCountryExt}${phoneNo}`;
    } else if (
      isNull(phoneExt) &&
      !isNull(phoneNo) &&
      (!associatedCountryExt || isUndefined(associatedCountryExt))
    ) {
      phoneNumber = `1${phoneNo}`;
    } else if (
      isNull(phoneNo) &&
      isNull(phoneExt) &&
      !isUndefined(associatedCountryExt)
    ) {
      phoneNumber = "1";
    } else {
      phoneNumber = "1";
    }
    return phoneNumber
      ? phoneNumber?.replace(/[^a-zA-Z0-9\s]/g, "")
      : undefined;
  }
};

// export const getDateTimeFormat = (datetime: any) => {
//     const dateTimeNew = dayjs(datetime);
//     return dateTimeNew
//       .set("hour", newTime.hour())
//       .set("minute", newTime.minute())
//       .set("second", newTime.second());
//   };

export const getExtensions = (
  data: any,
  countryListData: any[],
  countryCode: any,
) => {
  if (!isNull(data)) {
    const phoneNo = data?.phoneNo;
    const phoneExt = data?.phoneExt;
    const associatedCountry =
      !isEmpty(countryListData) &&
      first(
        countryListData?.filter(
          (country: { countryCode: any }) =>
            country.countryCode === countryCode,
        ),
      );
    const associatedCountryExt = getDialNumberBasedOnCountry(associatedCountry);
    let extensions = "";
    if (!isNull(phoneExt) && !isNull(phoneNo)) {
      extensions = phoneExt;
    } else if (
      isNull(phoneExt) &&
      !isNull(phoneNo) &&
      !isUndefined(associatedCountryExt)
    ) {
      extensions = associatedCountryExt;
    } else if (
      isNull(phoneExt) &&
      !isNull(phoneNo) &&
      (!associatedCountryExt || isUndefined(associatedCountryExt))
    ) {
      extensions = "1";
    } else if (
      isNull(phoneNo) &&
      isNull(phoneExt) &&
      !isNull(associatedCountryExt)
    ) {
      extensions = "1";
    } else {
      extensions = "1";
    }
    return extensions;
  }
};

export const getMenuItemsBasedOnPermissions = (permissions: any) => {
  return permissions?.map((el: any) => {
    return {
      id: el?.id,
      label: el?.module,
      actions: el?.actions,
      path: el?.path,
    };
  });
};

export const getRoleBasedLandingPage = (
  items: List<any> | null | undefined,
  navigate: (arg0: string) => void,
  _callback?: (activeKey: string, activeSubMenuKey: string | null) => void,
) => {
  const firstMenu = first(items);
  if (firstMenu) {
    navigate(firstMenu?.path);
  }
};

export const getGivenPermissions = (
  permissionsOfUser: any,
  screenName: string,
) => {
  const accessItems: any = first(
    permissionsOfUser?.filter(
      (el: any) => el.label?.toLowerCase() === screenName?.toLowerCase(),
    ),
  );
  const hasView = accessItems?.actions?.view;
  const hasEdit = accessItems?.actions?.edit;

  switch (screenName) {
    case "Users":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "Dashboard":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "Order Activity":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "Invoice Activity":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "Configuration":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "LtlCustomers":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "Settings":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "SettingsNew":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "Piaggio Customers":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "Lozier Store":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
    case "Carrier Tracking Activity":
      if (hasView && hasEdit) {
        return {
          hasFullAccess: true,
        };
      } else if (hasEdit) {
        return {
          hasEditAccess: true,
        };
      } else if (hasView) {
        return {
          hasViewAccess: true,
        };
      } else {
        return {
          hasNoAccess: true,
        };
      }
  }
};
export const getFileType = (fileName: string) => {
  const extension = fileName.split(".").pop()?.toLowerCase();
  if (extension === "pdf") return "pdf";
  if (["xlsx", "xls", "csv"].includes(extension || "")) return "excel";
  if (extension === "png") return "png";
  if (extension === "jpeg" || extension === "jpg") return "jpg";
  if (extension === "tif" || extension === "tiff") return "tiff";
  return "other";
};
export const generateDropdownForCustomerVendors = (
  masterLookup: any,
  userLoginData: any,
  type: any,
) => {
  const typeConfig: any = {
    vendor: {
      loginKey: "vendors",
      codeKey: "vendorId",
      nameKey: "vendorName",
      idKey: "vendorNo",
    },
    customer: {
      loginKey: "customers",
      codeKey: "companyCode",
      nameKey: "companyName",
      idKey: "id",
    },
  };

  const config = typeConfig[type];
  if (!config) {
    throw new Error('Invalid type provided. Must be "vendor" or "customer"');
  }

  const loginDetails = userLoginData[config.loginKey] || [];

  const codes = loginDetails.map((item: any) => item.name);
  const commaSeparatedCodes = codes.join(",");

  const mappedItems = loginDetails.map((item: any) => {
    return {
      id: item.id,
      name: item.name,
      code: item.name,
      label:
        type === "customer"
          ? masterLookup.filter((el: any) => el?.companyCode === item.name)[0]
              ?.companyName
          : masterLookup.filter((el: any) => el?.vendorId === item.name)[0]
              ?.vendorName,
      value: item.name,
    };
  });

  const arrayWithAll =
    loginDetails.length > 1
      ? [
          {
            id: "all",
            name: "All",
            code: "all",
            label: "All",
            value: "all",
          },
          ...mappedItems,
        ]
      : mappedItems;

  const filteredMasterLookup = masterLookup.filter(
    (masterItem: { companyCode: any; vendorId: any }) =>
      loginDetails.some((loginItem: { name: any }) =>
        type === "customer"
          ? masterItem.companyCode === loginItem.name
          : masterItem.vendorId === loginItem.name,
      ),
  );

  const filteredMasterLookupForAdmin = masterLookup;

  const filteredMasterLookupForCompleteResponse = userLoginData?.isAdmin
    ? filteredMasterLookupForAdmin.map((el: any) => {
        if (type === "customer") {
          return {
            ...el,
            id: el?.customerId,
            label: el?.companyName,
            value: el?.companyCode,
          };
        } else {
          return {
            ...el,
            id: el?.vendorNo,
            label: el?.vendorName,
            value: el?.vendorId,
          };
        }
      })
    : filteredMasterLookup.map((el: any) => {
        if (type === "customer") {
          return {
            ...el,
            id: el?.customerId,
            label: el?.companyName,
            value: el?.companyCode,
          };
        } else {
          return {
            ...el,
            id: el?.vendorNo,
            label: el?.vendorName,
            value: el?.vendorId,
          };
        }
      });

  const completeResponse = [
    {
      [config.idKey]: "all",
      [config.codeKey]: "All",
      [config.nameKey]: "All",
      label: "All",
      value: "all",
    },
    ...filteredMasterLookupForCompleteResponse,
  ];

  return {
    commaSeparatedCodes,
    arrayWithAll,
    completeResponse,
  };
};

/** Display API time strings such as "08:00:00" or "8:00:00" as "08:00". */
export const formatTimeOfDayForDisplay = (
  t: string | null | undefined,
): string => {
  if (t == null || typeof t !== "string") return "—";
  const trimmed = t.trim();
  if (!trimmed) return "—";
  const parts = trimmed.split(":");
  if (parts.length >= 2) {
    const h = parts[0].padStart(2, "0");
    const m = parts[1].padStart(2, "0");
    return `${h}:${m}`;
  }
  return trimmed;
};

/**
 * Serialize Ant Design TimePicker (dayjs), dayjs-like objects, or parseable strings
 * to `HH:mm:ss` (e.g. `08:00:00`) for APIs that expect time-of-day only, not full datetimes.
 */
export const formatTimeOfDayForPayload = (value: unknown): string | null => {
  const pattern = "HH:mm:ss";
  if (value == null || value === "") return null;
  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value.format(pattern) : null;
  }
  if (typeof value === "object" && value !== null && "format" in value) {
    const fmt = (value as { format: (f: string) => string }).format(pattern);
    return fmt || null;
  }
  const parsed = dayjs(value as string);
  return parsed.isValid() ? parsed.format(pattern) : null;
};

export const formatFloatingNumber = (value: any) => {
  if (value === null || isNaN(value)) {
    return 0;
  }

  const floatValue = parseFloat(value);
  const fixedValue = floatValue.toFixed(2);

  if (fixedValue.endsWith(".00")) {
    return Math.floor(floatValue);
  }

  return floatValue;
};

export const validateFloatingInput = (input: any, isThousand?: boolean) => {
  let sanitizedValue = input?.replace(/[^0-9.]/g, "");

  const decimalCount = (sanitizedValue?.match(/\./g) || [])?.length;
  if (decimalCount > 1) {
    sanitizedValue = sanitizedValue?.slice(0, sanitizedValue?.lastIndexOf("."));
  }

  sanitizedValue = isThousand
    ? sanitizedValue?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : sanitizedValue;

  const parts = sanitizedValue?.split(".");
  if (parts[1] && parts[1]?.length > 2) {
    parts[1] = parts[1]?.slice(0, 2);
    sanitizedValue = parts?.join(".");
  }
  return sanitizedValue;
};
export const serviceLevels: ServiceLevel[] = [
  { serviceLevelCode: "NF", serviceLevelDescription: "NF (0 or 1 Day)" },
  { serviceLevelCode: "ND", serviceLevelDescription: "ND (EXPRESS or 1 Day)" },
  { serviceLevelCode: "2D", serviceLevelDescription: "2D (2 Days)" },
  { serviceLevelCode: "3D", serviceLevelDescription: "3D (3 Days)" },
  { serviceLevelCode: "4D", serviceLevelDescription: "4D (4 Days)" },
  { serviceLevelCode: "5D", serviceLevelDescription: "5D (5 Days)" },
  { serviceLevelCode: "6D", serviceLevelDescription: "6D (6 Days)" },
  { serviceLevelCode: "TN", serviceLevelDescription: "TN (10 Days)" },
  { serviceLevelCode: "DF", serviceLevelDescription: "DF (30 Days)" },
  { serviceLevelCode: "LC", serviceLevelDescription: "Local PU&D" },
];
export const delByValue: DelByValue[] = [
  { delByValueCode: "BY", delByValueDescription: "BY" },
  { delByValueCode: "ONLY", delByValueDescription: "ONLY" },
  { delByValueCode: "BETWEEN", delByValueDescription: "BETWEEN" },
];

export const referenceTypeOptions = [
  { value: "Purchase Order", label: "Purchase Order" },
  { value: "Sales Order #", label: "Sales Order #" },
  { value: "DLV Order", label: "DLV Order" },
  { value: "Consignee Ref", label: "Consignee Ref" },
  { value: "Project #", label: "Project #" },
  { value: "Shipper Ref", label: "Shipper Ref" },
  { value: "Reference", label: "Reference" },
  { value: "Other", label: "Other" },
];

// Customer Type Options for dropdowns
export const customerTypeOptions = [
  { value: "BillTo", label: "Bill To" },
  { value: "Shipper", label: "Shipper" },
  { value: "Consignee", label: "Consignee" },
];

// Reference No Options for dropdowns

// Get reference type code by description
